module.exports = __webpack_public_path__ + "static/media/noticia.13824e88.png";